export enum Message {
  GeneratePattern = 'generatePattern',
  ModelCreated = 'modelCreated',
  GenerateFinished = 'generateFinished',
  Result = 'result',
}
